/**
 * 連続学習日数をヘッダーに出すかどうか。
 *
 * **1 日以下では出さない。** 続いている実感が無いうちに「1 日」と出すのは、
 * 積み上げの表示ではなく「まだ何もしていない」の通知になる。0 日に至っては
 * 開いた人を出迎える言葉として最悪で、続ける気を削ぐ側に働く。
 *
 * 上限も置かない。365 日で頭打ちにするのは api-go 側の走査上限であって、
 * 表示の都合ではない。
 */
export const STREAK_MIN_DAYS = 2;

export function shouldShowStreak(days: number | null | undefined): boolean {
  if (typeof days !== "number" || !Number.isFinite(days)) return false;
  return days >= STREAK_MIN_DAYS;
}

/** 「12日」。桁が増えても崩れないよう数字と単位を分けて返す */
export function streakLabel(days: number): { value: string; unit: string } {
  return { value: String(days), unit: "日" };
}
